const isLocal = process.env.NEXT_PUBLIC_APP_TIER === 'local';

const isTest = process.env.NEXT_PUBLIC_APP_TIER === 'test';

const isProduction = process.env.NEXT_PUBLIC_APP_TIER === 'production';

export { isLocal, isTest, isProduction };
